var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"content-header",class:!_vm.title ? 'no-text bg-secondary' : '',style:(`background-image: url(${_vm.background})`)},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"mx-auto border-warning"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }